// extracted by mini-css-extract-plugin
var _1 = "vddV0hcL";
var _2 = "fc5Krxn2";
var _3 = "DjsQZilJ";
export { _1 as "cancelBtn", _2 as "content", _3 as "modal" }
